export default __webpack_public_path__ + "static/media/business_login.4bff01b3.svg";